const AUTH_QUERY_KEYS = ['data', 'nonce', 'returnUrl'];

export const readPortalEntry = (locationLike) => {
  const searchParams = new URLSearchParams(locationLike.search || '');
  let nonce = searchParams.get('data') || searchParams.get('nonce');
  let returnUrl = searchParams.get('returnUrl');

  const hash = locationLike.hash || '';
  if ((!nonce || !returnUrl) && hash.includes('?')) {
    const hashParams = new URLSearchParams(hash.slice(hash.indexOf('?') + 1));
    nonce ||= hashParams.get('data') || hashParams.get('nonce');
    returnUrl ||= hashParams.get('returnUrl');
  }

  return { nonce, returnUrl };
};

export const sanitizePortalEntryUrl = (rawUrl) => {
  const url = new URL(rawUrl);
  AUTH_QUERY_KEYS.forEach((key) => url.searchParams.delete(key));

  if (url.hash.includes('?')) {
    const questionMarkIndex = url.hash.indexOf('?');
    const hashPath = url.hash.slice(0, questionMarkIndex);
    const hashParams = new URLSearchParams(url.hash.slice(questionMarkIndex + 1));
    AUTH_QUERY_KEYS.forEach((key) => hashParams.delete(key));
    const remainingQuery = hashParams.toString();
    url.hash = remainingQuery ? `${hashPath}?${remainingQuery}` : hashPath;
  }

  return url.toString();
};

export const getSafeInternalRoute = (candidate) => {
  if (typeof candidate !== 'string') return '/';
  const [pathname, query = ''] = candidate.split('?');
  const isAllowed = pathname === '/' || pathname === '/plans' || pathname === '/history';
  return isAllowed ? `${pathname}${query ? `?${query}` : ''}` : '/';
};
